export default __webpack_public_path__ + "static/media/A_Abelha.d3dfae22.svg";